<script>
  import { onMount } from 'svelte';
  import { authStore } from '../authStore';
  import { getApiUrl } from '../api';
  import PromotionCard from '../components/PromotionCard.svelte';

  let promotions = [];
  let isLoading = true;
  let error = '';
  let currentUser = null;

  // Subscribe to the store to get the user object
  authStore.subscribe(value => {
    currentUser = value.user;
  });

  // This is a reactive block. It will automatically run
  // AFTER `currentUser` receives a value from the store, preventing race conditions.
  $: if (currentUser) {
    fetchFavourites();
  }

  async function fetchFavourites() {
    isLoading = true;
    error = '';
    try {
      const userId = currentUser?.idTokenClaims?.oid;
      if (!userId) {
        // This check now acts as a safeguard
        throw new Error('You must be logged in to view this page.');
      }
      const response = await fetch(getApiUrl(`/favourites/${userId}`));
      if (!response.ok) throw new Error('Could not fetch your favourite promotions.');
      promotions = await response.json();
    } catch (e) {
      error = e.message;
    } finally {
      isLoading = false;
    }
  }
</script>

<div class="page-container">
  <h2>My Favourites</h2>
  
  {#if isLoading}
    <p>Loading your favourites...</p>
  {:else if error}
    <p class="error">{error}</p>
  {:else if promotions.length === 0}
    <p>You haven't added any promotions to your favourites yet.</p>
  {:else}
    <div class="promo-list">
      {#each promotions as promo (promo._id)}
        <PromotionCard {promo} />
      {/each}
    </div>
  {/if}
</div>

<style>
  .page-container { 
    max-width: 1200px; 
    margin: 2rem auto; 
  }
  .promo-list { 
    display: grid; 
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr)); 
    gap: 1.5rem; 
  }
  .error { 
    color: red; 
    font-weight: bold;
    text-align: center;
  }
</style>
